import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/authentitcation/auth.service';
import { map } from 'rxjs';

export const loginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.isUserAuthenticated().pipe(
    map((authenticated) => {
      if (authenticated) {
        return router.createUrlTree(['/timer']);
      } else {
        return true;
      }
    })
  );
};
